module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0iii-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fmot"
  }, [_vm._v("I’d like to thank Daphne Tilley, for taking me on a long-distance ride across Snowdon to the Lleyn Peninsula, where I discovered the drovers’ roads and the beginnings of my story. Jenny and David Clifford, for lending me their house. Turkish Airlines, for flying me to Istanbul, where I took a boat across the Bosphorus and saw Florence Nightingale’s room at the Barrack Hospital; Alex Attewell, director of the Florence Nightingale Museum at St. Thomas’s Hospital in London for his advice. Special thanks to Delia.")]), _vm._v(" "), _c('p', {
    staticClass: "fmtx"
  }, [_vm._v("For love and support, thanks to my late mother, Vicki Sutton; to my sister Caroline; to Sarah, Charlotte, Hugo, Natasha, and Poppy; and, of course, Richard, for patiently reading all those drafts. I owe Kate Shaw a big debt of gratitude for her advice and support, and many thanks to my agent, Clare Alexander, for her professionalism and encouragement.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3496e2c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/002.vue
// module id = 66
// module chunks = 0